<template>
  <div>
    <div class="titre-h3 mt-3 mb-3 ml-1">
      Foire aux questions
    </div>
    <v-card class="pa-5">
      <div class="mt-6">
        <BaseMessageServerError v-if="serverError && !loading" />
        <FaqThemes
          v-if="!loading"
          :faq-themes="formattedThemes"
        />
      </div>
    </v-card>
  </div>
</template>

<script>
import FaqThemes from './components/faq-theme.vue'
import { mapActions, mapGetters } from 'vuex'
import BaseMessageServerError from '@/components/common/base-message-server-error.vue'
import {clone} from '@/utils/clone'

export default {
  name: 'FaqUtilisateur',
  components: { FaqThemes, BaseMessageServerError },

  data () {
    return {
      formattedThemes: [],
      loading: false,
      serverError: false
    }
  },

  computed: {
    ...mapGetters({
      faqThemes: 'faq/faqThemes'
    }),
  },

  created () {
    this.loadThemes()
    this.updateCodeGraineActive(null)
  },

  methods: {
    ...mapActions({
      getFaqThemes: 'faq/getFaqThemes',
      updateCodeGraineActive: 'application/updateCodeGraineActive',
    }),

    loadThemes () {
      this.loading = true
      this.getFaqThemes()
        .then(() => {
          this.formattedThemes = clone(this.faqThemes)

          for (const theme of this.formattedThemes) {
            for (const question of theme.questionsReponses) {
              question.isDejaVu = this.$cookies.get('FAQ_QUESTION_DEJA_VU_'+question.id) !== null
            }
          }
        })
        .catch(() => {
          this.serverError = true
        })
        .finally(() => this.loading = false)
    }
  }
}
</script>
